import { useContext } from 'react';
import { ReportsFilterContext, ReportsFilterContextData } from './context';

export function useReportsFilter(): ReportsFilterContextData {
    const data = useContext<ReportsFilterContextData | undefined>(
        ReportsFilterContext
    );

    if (!data) {
        throw new Error(
            "ReportsFilterContext unavailable. Are you sure you're using this in a nested component of an ReportsFilterProvider?"
        );
    }

    return data;
}
